<template>
  <div class="code">
    <h2 class="title">{{ $t('home.menu.code') }}</h2>
    <div class="code">
      <img v-if="qrcode && qrcode.qrcodeUrl && !loading" :src="qrcodeUrl" />
      <Loading v-if="loading" color="#0094ff" />
    </div>
    <div class="button">
      <div @click="getQrcode">
        <img :src="refreshSvg" />
        <span>{{ $t('qrcode.refresh') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/services/api';
import refreshSvg from '@/assets/icon/refresh.svg';
import { Loading } from 'vant';
import { replaceUrl } from '@/utils/url-ip-replace';
export default {
  name: 'qrcode',
  components: {
    Loading,
  },
  data() {
    return {
      qrcode: null,
      refreshSvg,
      loading: false,
    };
  },
  computed: {
    qrcodeUrl() {
      return replaceUrl(this.qrcode?.qrcodeUrl);
    },
  },
  methods: {
    async getQrcode() {
      this.loading = true;
      const [status, res] = await api.getQrcode();
      this.loading = false;
      console.log(res);
      if (!status) return;
      this.qrcode = res.data;
    },
  },
  created() {
    this.getQrcode();
  },
};
</script>

<style lang="less" scoped>
.code {
  margin: 30px;
  background: #fff;
  border-radius: 10px;
  text-align: center;
  .title {
    font-size: 36px;
    padding: 40px 0;
  }
  .code {
    width: 386px;
    border: 1px solid #E0E0E0;
    margin: 0 auto;
    padding-top: 2px;
    min-height: 386px;
    /deep/.van-loading {
      margin-top: 150px;
    }
    img {
      width: calc(100% - 2px);
      height: calc(100% - 2px);
    }
  }
  .button {
    padding: 40px 0 80px 0;
    font-size: 32px;
    color: #949AA4;
    cursor: pointer;
    div {
      display: inline-block;
    }
    img {
      width: 32px;
      vertical-align: middle;
      padding-right: 12px;
    }
  }
}
</style>
